var exports = {
  "w": "Footer__JfyQtm",
};

module.exports = exports;
